import React, { useState, useEffect, useRef } from 'react';
import {
  useFirebaseContext,
  useAllInOneContext,
  useActiveListContext,
} from '../../../context';
import { Core } from '../..';
import { handleClickOutside } from '../../../hooks';
import { UpgradeAccount } from '../auth';
import { ImageUpload } from '../image_upload';
import { CSSTransition } from 'react-transition-group';
import '../../core/styles/styles.css';
import { Profile, ConfirmButtons, OverlayButton, Container } from './styles';
import { resizeOnInput } from '../../../helpers';
import {
  FaSignOutAlt,
  FaUserCheck,
  FaUserTimes,
} from 'react-icons/fa';
import { storage } from '../../../lib';

export const UserDetails = () => {
  const { firebase } = useFirebaseContext();
  const { lists, allTasks } = useAllInOneContext();
  const { themeColor, themeColor_L2 } = useActiveListContext();
  const [showBox, setShowBox] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isGuest, setIsGuest] = useState(false);
  const [user, setUser] = useState();
  const [userName, setUserName] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [photoURL, setPhotoURL] = useState();
  const [showUpgradeAccBox, setShowUpgradeAccBox] = useState(false);
  const [email, setEmail] = useState();

  const [nameEditMode, setNameEditMode] = useState(false);
  const wrapperRef = useRef();
  const handleRef = useRef();
  const textareaRef = useRef();

  useEffect(() => {
    if (!showBox && user) {
      setNameEditMode(false);
      setUserName(user.displayName);
    }
  }, [showBox]);

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.value = userName;

      resizeOnInput(textareaRef.current);
    }
  }, [showBox, nameEditMode, textareaRef, userName]);

  useEffect(() => {
    const user = firebase.auth().currentUser;

    setUser(user);

    setUserName(user.displayName);
    setPhotoURL(user.photoURL ? user.photoURL : `/images/user/default.png`);
    setEmail(user.email);

    if (user.isAnonymous) setIsGuest(true);
  }, []);

  const handleSignOut = (deleteAction = false) => {
    if (isGuest || deleteAction) {
      setShowAlert(true);
      const firestore = firebase.firestore();
      setProgress(5);

      const taskDB = firestore
        .collection('users')
        .doc(user.uid)
        .collection('tasks');

      allTasks.map((doc) => taskDB.doc(doc.docID).delete());
      setProgress(55);

      const listDB = firestore
        .collection('users')
        .doc(user.uid)
        .collection('lists');

      lists.map((doc) => listDB.doc(doc.docID).delete());
      try {
        if (
          deleteAction &&
          user.photoURL &&
          user.photoURL != `/images/user/default.png` &&
          storage.refFromURL(user.photoURL)
        )
          storage.refFromURL(user.photoURL).delete();
      } catch (e) {
        console.log('Skipped');
      }

      setProgress(95);

      firebase
        .firestore()
        .collection('users')
        .doc(user.uid)
        .delete()
        .then(() => {
          setShowAlert(false);
          firebase.auth().signOut();

          user.delete();
        });
    } else firebase.auth().signOut();

    document.title = `Ame`;
  };

  const updateUserName = () => {
    if (user && user.displayName != userName) {
      user.updateProfile({
        displayName: userName,
      });
    }
  };
  handleClickOutside(wrapperRef, { setShowBox }, handleRef);
  return (
    <>
      <Core.ForceAlert
        progress={progress}
        setProgress={setProgress}
        color={themeColor}
        showBox={showAlert}
      >
        Deleting user data...
      </Core.ForceAlert>

      <Profile
        ref={handleRef}
        style={{
          borderRadius: '50%',
          cursor: 'pointer',
          border: '4px solid white',
          boxSizing: 'border-box',
          marginLeft: '15px',
        }}
        onClick={() => setShowBox(!showBox)}
        src={photoURL}
      />

      <Container showBox={showBox}>
        <CSSTransition
          in={showBox}
          timeout={300}
          classNames='slide-down'
          unmountOnExit
        >
          <div
            ref={wrapperRef}
            style={{
              borderRadius: '25px',
              minWidth: '250px',
              padding: '10px',
              background: 'white',
              overflow: 'hidden',
              boxShadow: 'rgb(0 0 0 / 15%) 0px 0px 8px 4px',
            }}
          >
            <Core.ListLayout>
              {isGuest && (
                <>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '10px 0px 20px 0px',
                    }}
                  >
                    You are logged in as Guest
                  </div>



                  <OverlayButton
                    background={themeColor}
                    color={'white'}
                    display={'top'}              
                    onClick={() => setShowUpgradeAccBox(true)}
                  >
                    <FaUserCheck />
                    <span>Link Account</span>
                  </OverlayButton>

                  <UpgradeAccount
                    showUpgradeAccBox={showUpgradeAccBox}
                    setShowUpgradeAccBox={setShowUpgradeAccBox}
                  />
                </>
              )}

              {!isGuest && (
                <>
                  <div style={{ display: 'flex' }}>
                    <div
                      style={{
                        position: 'relative',
                        width: '80px',
                        height: '80px',
                        borderRadius: '15px',
                        overflow: 'hidden',
                        display: 'flex',
                      }}
                    >
                      <img
                        style={{ width: '100%', height: '100%' }}
                        src={photoURL}
                      />
                      <ImageUpload
                        style={{
                          position: 'absolute',
                          zIndex: 1,
                          bottom: 0,
                          right: 0,
                        }}
                        setShowParentBox={setShowBox}
                        user={user}
                        setPhotoURL={setPhotoURL}
                      />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          paddingLeft: '10px',
                        }}
                      >
                        <Core.NameInput
                          rows='1'
                          forwardedRef={textareaRef}
                          placeholder='Name'
                          value={userName ? userName : ''}
                          onChange={({ target }) => {
                            setNameEditMode(true);
                            setUserName(target.value);
                          }}
                        ></Core.NameInput>
                        {nameEditMode && (
                          <ConfirmButtons color={themeColor}>
                            <div
                              className='button-confirm button'
                              disabled={userName == ''}
                              onClick={() => {
                                setNameEditMode(false);
                                updateUserName();
                              }}
                            >
                              Save
                            </div>
                            <div
                              className='button-cancel button'
                              onClick={() => {
                                setNameEditMode(false);
                                setUserName(user.displayName);
                              }}
                            >
                              Cancel
                            </div>
                          </ConfirmButtons>
                        )}
                      </div>

                      <p
                        style={{
                          opacity: '0.8',
                          wordBreak: 'break-all',
                          padding: '0 10px',
                        }}
                      >
                        {email}
                      </p>
                    </div>
                  </div>

                  <OverlayButton
                    background={'#ead4d2'}
                    color={'#ea4e3d'}
                    display={'top'}
                    onClick={() => {
                      handleSignOut(true);
                    }}
                    style={{ marginTop: '10px' }}
                  >
                    <FaUserTimes />
                    <span>Delete Account</span>
                  </OverlayButton>
                </>
              )}

              <OverlayButton
                background={themeColor_L2}
                color={themeColor}
                onClick={() => handleSignOut()}
                style={{ marginTop: '0px' }}
                display={'bottom'}
              >
                {isGuest ? (
                  <>
                    <FaUserTimes />
                    <span>Delete Account</span>
                  </>
                ) : (
                  <>
                    <FaSignOutAlt />
                    <span>Sign Out</span>
                  </>
                )}
              </OverlayButton>
            </Core.ListLayout>
          </div>
        </CSSTransition>
      </Container>
    </>
  );
};
